import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=66d7066e&scoped=true"
import script from "./CustomFields.vue?vue&type=script&lang=js"
export * from "./CustomFields.vue?vue&type=script&lang=js"
import style0 from "./CustomFields.vue?vue&type=style&index=0&id=66d7066e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d7066e",
  null
  
)

export default component.exports